import React from "react";

import {
  PictureOutlined,
  VideoCameraOutlined,
  FileOutlined,
} from "@ant-design/icons";

export default function UploadCard({ type, onClick }) {
  const iconStyle = { fontSize: "24px" };
  const textStyle = {
    cursor: "pointer",
    fontSize: "16px",
    paddingTop: "8px",
  };

  const getCardContent = () => {
    switch (type) {
      case "video":
        return {
          icon: <VideoCameraOutlined style={iconStyle} />,
          text: "Add a Video",
        };
      case "file":
        return {
          icon: <FileOutlined style={iconStyle} />,
          text: "Add a PDF File",
        };
      case "image":
      default:
        return {
          icon: <PictureOutlined style={iconStyle} />,
          text: "Add an Image",
        };
    }
  };

  const { icon, text } = getCardContent();

  return (
    <div className="upload-placeholder" onClick={onClick}>
      {icon}
      <br />
      <span style={textStyle}>{text}</span>
    </div>
  );
}
